import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Dialog, Notify, Quasar } from 'quasar';

import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import './css/app.scss';

import App from './App.vue';
import { router } from './router';
import { useUiStore } from './stores/ui';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(Quasar, {
  plugins: { Notify, Dialog },
  config: {
    notify: { position: 'top', timeout: 3000 },
    brand: {},
  },
});

// Tema aplicado antes do primeiro paint: evita o flash de tema claro
// para quem usa escuro.
useUiStore(pinia).applyTheme();

app.use(router);

/**
 * Erro não tratado em componente. Vai para o console em dev e, em
 * produção, seria enviado ao Sentry. O usuário não vê stack trace.
 */
app.config.errorHandler = (err, _instance, info) => {
  console.error('[vue:error]', info, err);
};

app.mount('#app');
